export default {"src":"/_next/static/media/logo Safir Uni en.d4a5bea0.svg","height":164,"width":392,"blurWidth":0,"blurHeight":0};